/**
 * 价目查询、科室查询、专家介绍等参考内容
 */
import http from "@/utils/axiosoUtil";

const mutations = {
  // 设置价目查询类别
  setPriceQeuryTypes(state, list) {
    state.priceQeuryTypes = list;
  },
  // 设置价目查询明细
  setPriceQeuryList(state, list) {
    state.priceQueryList = list;
  }
};

const state = {
  priceQeuryTypes: [],
  priceQueryList: []
};

const actions = {
  // 获取价目查询类别
  getPriceQeuryTypes({ commit }) {
    http.get(http.api.REFRENCE_PRICE_QUERY_TYPE).then(res => {
      const tabs = res.typeList.map(item => {
        return {
          name: item.typeName,
          type: item.TwoTypeFlag
        };
      });
      commit("setPriceQeuryTypes", tabs);
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
